import { render, staticRenderFns } from "./dashboardV2.vue?vue&type=template&id=76dccfc8&scoped=true"
import script from "./dashboardV2.vue?vue&type=script&lang=js"
export * from "./dashboardV2.vue?vue&type=script&lang=js"
import style0 from "./dashboardV2.vue?vue&type=style&index=0&id=76dccfc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dccfc8",
  null
  
)

export default component.exports